module.exports = __webpack_public_path__ + "img/build-and-release-pipelines.f1e6ce1c.png";